export const isMobile = window.matchMedia(
  "screen and (max-width: 768px)"
).matches;

export const isInsideIframe = () => {
  try {
      return window.self !== window.top;
  } catch (e) {
    return true;
  }
}
